import React from 'react';
import {useFormikContext} from "formik";

import Postnl from "./Postnl";
import Nshift from "./Nshift";
import ColissimoViaToopost from "./ColissimoViaToopost";
import MondialRelayViaToopost from "./MondialRelayViaToopost";
import Geodis from "./Geodis";

import {ShippingMethodsDiscr} from "utils/ShippingMethods";
import Colissimo from "./Colissimo";

function AdditionalDataFields(props) {
    const {values} = useFormikContext();

    if (!values?.discr) {
        return null
    }

    switch (values.discr) {
        case ShippingMethodsDiscr.POSTNL:
            return <Postnl />;
        case ShippingMethodsDiscr.NSHIFT:
            return <Nshift />
        case ShippingMethodsDiscr.COLISSIMO_VIA_TOOPOST:
            return <ColissimoViaToopost />
        case ShippingMethodsDiscr.MONDIAL_RELAY_VIA_TOOPOST:
            return <MondialRelayViaToopost />
        case ShippingMethodsDiscr.GEODIS:
            return <Geodis />
        case ShippingMethodsDiscr.COLISSIMO:
            return <Colissimo />
        default:
            return null;
    }
}

export default AdditionalDataFields;
